import IncidentElement from "./Incident";
import {IIncident} from "../../rz-status_models";
import Parser from "../../rz-status_parser";
import { useState, useEffect } from 'react';
import SearchEngine from "../../rz-status_search";
import SearchField from "./SearchField";
import EventCounter from "./eventCounter";
import { useTimer } from "../contextProviders/TimerContext";
import { useCollapse } from "../contextProviders/CollapseContext";
import useData from "../useData";
import Constants from "../../rz-status_constants";

export default function()  {
	const { expanded, toggle} = useCollapse();
    const tick = useTimer();

    const [past, setPast] = useState<null | IIncident[]>([]);
	const parser = new Parser();
	const [search, _] = useState(new SearchEngine(["Sla", "startDate","endDate"]));


	const { data, error, loading } = useData(Constants.Paths.lastIncidentsJsonPath, (file) => parser.parseIncidents(file), [tick]);
	useEffect(() => {
		if (!data) return;
		search.setData(data);
		search.search();
		setPast((search.getResults() as IIncident[]).sort((a, b) => (b.startDate - a.startDate || b.endDate - a.endDate)))
	}, [data])

	return <article className={"fixedIncidents collapsible" + ((expanded == 1) ? " open" : "")} id="fixedIncidents">
			<header>
				<h2>
					<button className="incidentTitle" aria-expanded={(expanded == 1) ? "true" : "false"} aria-controls="generated_content_incident_history" onClick={() => toggle(1)} aria-label={`Behobene Störungen der letzten 3 Tage ${(expanded == 1) ? "schließen" : "öffnen"}`}>
						<span className="h2" id="fixedIncidentsTitle">Behobene Störungen der letzten 3 Tage</span>
						<div>
							<EventCounter id="fixedIncidentsNumber" countable={data}/>
							<span className="arrow"></span>
						</div>
					
					</button>
				</h2>
			</header>
			<div id="generated_content_incident_history" className="collapsible-content">
				{ error || data == null 
					? <section className="details clearfix"><div><p>Daten aktuell nicht abrufbar</p></div></section>
					: <>
					<section className="searchAndFilter">
						<form autoComplete="off" role="search" aria-label="Behobene Störungen der letzten 3 Tage durchsuchen">
							<SearchField onFilterChange={e => {
								search.setSearchTerm(e);
								search.search();
								setPast(search.getResults() as IIncident[]);}}/>				
						</form>
					</section>
					<section>
						{past == null || past.length == 0
							? <div><p>{data?.length > 0 ? "Ihre Auswahl ergab keine Treffer. Ändern Sie ggf. Ihre Such-Anfrage, um behobene Störungen anzuzeigen." : "Keine Störungen aufgetreten."}</p></div>
							: <table className="incidents" aria-labelledby="fixedIncidentsTitle">
								<thead>
									<tr>
										<th className="application">Anwendung</th>
										<th className="date start">Beginn</th>
										<th className="date end">Ende</th>
										<th className="state">Verfügbarkeit</th>
									</tr>
								</thead>
								<tbody>
									{past.map((incident, i) => <IncidentElement key={i} incident={incident} worst/>)}
								</tbody>
							</table>
						}
					</section>
				</>}
			</div>			
		</article>
}